export default "__VITE_ASSET__DA57gD2I__"